export default __webpack_public_path__ + "static/media/chain-16.05a9c4bf.png";